import { Select } from 'antd';
import React, { useState, useEffect } from 'react';
import axios from 'axios';

const { Option } = Select;

export default function SelectAzienda({ value, onChange, disabled, onAziendaChange }) {
    const [aziende, setAziende] = useState([]);

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_SERVER_URL}/api/aziende/all`)
            .then((response) => {
                setAziende(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    const handleChange = (val) => {
        const aziendaSelezionata = aziende.find(a => a.codice === val);
        if (onAziendaChange) {
            onAziendaChange(aziendaSelezionata);
        }
        if (onChange) {
            onChange(val); // importante per AntD Form
        }
    };

    return (
        <Select
            showSearch
            style={{ width: 130 }}
            placeholder="Selezionare una convenzione"
            optionFilterProp="children"
            onChange={handleChange}
            onFocus={() => console.log('focus')}
            onBlur={() => console.log('blur')}
            onSearch={(val) => console.log('search:', val)}
            filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            value={value}
            disabled={disabled}
        >
            <Option value="">Nessuna</Option>
            {aziende.map((azienda) => (
                <Option key={azienda.codice} value={azienda.codice}>
                    {azienda.nome}
                </Option>
            ))}
        </Select>
    );
}
